var _rect, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMemberPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "#E8EDF2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 82,
    r: 38,
    fill: "#B0BCCB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 190 C20 145 60 120 100 120 C140 120 180 145 180 190",
    fill: "#B0BCCB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMemberPlaceholder);
export default __webpack_public_path__ + "static/media/member-placeholder.53d304a213b93d0aa351e70e7c131508.svg";
export { ForwardRef as ReactComponent };